import React from "react";
import {
  TextField,
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import modelApplications from "../../constants/modelApplications.json";

const TrainedModelFormFields = ({
  form,
  handleChange,
  width = "50%",
  selectedZoo,
  setSelectedZoo,
}) => {
  return (
    <>
      <Typography variant="h3" fontWeight={700} color="black" mt={4}>
        New Model Info
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Fill in your model details to import it to the Model Zoo.
      </Typography>

      <Box
        sx={{
          width,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          mt: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 4, // spacing between name and checkboxes
            mt: 0,
          }}
        >
          <TextField
            required
            label="Model name"
            name="modelName"
            value={form.modelName || ""}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            disabled={form.in_model_zoo_public || form.in_model_zoo_private} // disable if in any zoo
          />

          {/* Public/Private checkboxes temporarily hidden — models are public by default */}
          {/*
          <FormControlLabel
          
            control={
              <Checkbox
                checked={selectedZoo.public}
                  sx={{
                  color: 'rgb(158, 151, 151)',
                  '&.Mui-checked': {
                    color: '#16a4b0',
                  },
                }}
                onChange={(e) =>
                  setSelectedZoo((prev) => ({ ...prev, public: e.target.checked }))
                }
                disabled={form.in_model_zoo_public} // disable only if already public
              />
            }
            label="Public"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedZoo.private}
                sx={{
                  color: 'rgb(158, 151, 151)',
                  '&.Mui-checked': {
                    color: '#16a4b0',
                  },
                }}
                onChange={(e) =>
                  setSelectedZoo((prev) => ({ ...prev, private: e.target.checked }))
                }
                disabled={form.in_model_zoo_private} // disable only if already private
              />
            }
            label="Private"
          />
          */}
        </Box>

        <TextField
          required
          label="Describe your model"
          name="description"
          value={form.description || ""}
          onChange={handleChange}
          multiline
          rows={2}
          fullWidth
          autoComplete="off"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          disabled={form.in_model_zoo_public || form.in_model_zoo_private}
        />

        <FormControl
          required
          fullWidth
          disabled={form.in_model_zoo_public || form.in_model_zoo_private}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
        >
          <InputLabel id="application-label">Application</InputLabel>
          <Select
            labelId="application-label"
            label="Application"
            name="application"
            value={form.application || ""}
            onChange={handleChange}
          >
            {modelApplications.map((application) => (
              <MenuItem key={application.value} value={application.value}>
                {application.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Image Upload */}
        <Typography variant="h7" color="black">
          Test images (1-3 required)
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Button
            variant="outlined"
            component="label"
            disabled={form.in_model_zoo_public || form.in_model_zoo_private}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              justifyContent: "center",
              color: "rgba(0, 0, 0, 0.67)",
              borderColor: "rgba(0, 0, 0, 0.23)",
              backgroundColor: "white",
              "&:hover": {
                borderColor: "black",
                backgroundColor: "rgba(0,0,0,0.04)",
              },
              padding: "14px 14px",
              fontWeight: 400,
              fontSize: "16px",
            }}
            fullWidth
          >
            Upload Images*
            <input
              type="file"
              name="modelTestImages"
              accept=".png,.jpg,.jpeg"
              multiple
              hidden
              required
              onChange={(e) => {
                const newFiles = Array.from(e.target.files);
                const existingFiles = form.modelTestImages || [];
                const merged = [...existingFiles, ...newFiles].slice(0, 3); // max 3

                handleChange({
                  target: {
                    name: "modelTestImages",
                    type: "file-multi",
                    value: merged,
                  },
                });

                e.target.value = null; // allow same file to be re-selected
              }}
            />
          </Button>

          {/* Preview */}
          {form.modelTestImages?.length > 0 && (
            <Box sx={{ mt: 1, fontSize: "0.9rem", color: "gray" }}>
              {form.modelTestImages.map((file, idx) => (
                <div key={idx}>{file.name}</div>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TrainedModelFormFields;
